import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "flex flex-col gap-2" }

import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import type { Column } from '@tanstack/vue-table';
    import { formatCurrency } from '@/utils/helpers';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';

    interface Props {
        column: Column<any, unknown>;
        modelValue?: [number | undefined, number | undefined] | undefined;
    }

    interface Emits {
        (e: 'update:modelValue', value: [number | undefined, number | undefined] | undefined): void;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnNumberRange',
  props: {
    column: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emit = __emit;
    const { t } = useI18n();

    const fromValue = computed<number | undefined>({
        get() {
            return props.modelValue?.[0];
        },
        set(value: number | undefined) {
            updateFilterValue(value, toValue.value);
        },
    });

    const toValue = computed<number | undefined>({
        get() {
            return props.modelValue?.[1];
        },
        set(value: number | undefined) {
            updateFilterValue(fromValue.value, value);
        },
    });

    const updateFilterValue = (from: number | undefined, to: number | undefined) => {
        if (from === undefined && to === undefined) {
            emit('update:modelValue', undefined);
            return;
        }

        emit('update:modelValue', [from, to]);
    };

    const minPlaceholder = computed(() => {
        let min: number | string = props.column.getFacetedMinMaxValues()?.[0] ?? 0;

        if (props.column.columnDef.meta?.filterType === 'currency') {
            min = formatCurrency(min);
        }

        return `Min (${min})`;
    });

    const maxPlaceholder = computed(() => {
        let max: number | string = props.column.getFacetedMinMaxValues()?.[1] ?? 0;

        if (props.column.columnDef.meta?.filterType === 'currency') {
            max = formatCurrency(max);
        }

        return `Max (${max})`;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Label), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('forms.from')), 1)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(
                    props.column.columnDef.meta?.filterType === 'currency'
                        ? ThousandSeparatorInput
                        : _unref(Input)
                ), {
        modelValue: fromValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromValue).value = $event)),
        type: props.column.columnDef.meta?.filterType === 'currency' ? 'text' : 'number',
        step: "any",
        placeholder: minPlaceholder.value,
        "with-decimals": ""
      }, null, 8, ["modelValue", "type", "placeholder"]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Label), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('forms.to')), 1)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(
                    props.column.columnDef.meta?.filterType === 'currency'
                        ? ThousandSeparatorInput
                        : _unref(Input)
                ), {
        modelValue: toValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toValue).value = $event)),
        type: props.column.columnDef.meta?.filterType === 'currency' ? 'text' : 'number',
        step: "any",
        placeholder: maxPlaceholder.value,
        "with-decimals": ""
      }, null, 8, ["modelValue", "type", "placeholder"]))
    ])
  ]))
}
}

})